import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { take } from 'rxjs';
import { filter } from 'rxjs/operators';
import { OnboardingProcessActions } from '../state/actions/onboarding-process.actions';
import { selectIsApplicantAMember } from '../state/selectors/pre-application.selectors';
import { OnboardingProcessFlowService } from './onboarding-process-flow.service';

@Injectable({
	providedIn: 'root',
})
export class NavigationSyncService {
	private historyStack: string[] = [];
	private isPopStateNavigation = false;

	constructor(
		private router: Router,
		private store: Store,
		private onboardingFlow: OnboardingProcessFlowService
	) {}

	init() {
		window.addEventListener('popstate', () => {
			this.isPopStateNavigation = true;
		});

		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd) => {
				const currentUrl = event.urlAfterRedirects;
				if (this.isPopStateNavigation) {
					this.handlePopNavigation(currentUrl);
				} else {
					this.historyStack.push(currentUrl);
				}
				this.isPopStateNavigation = false;
			});
	}

	private handlePopNavigation(currentUrl: string) {
		const previousIndex = this.historyStack.lastIndexOf(currentUrl);
		if (previousIndex !== -1) {
			this.historyStack = this.historyStack.slice(0, previousIndex + 1);
		} else {
			this.historyStack.push(currentUrl);
		}

		// El navegador ya cambió de pantalla, así que el store se alinea con la
		// URL en lugar de pedirle al flujo que retroceda un paso por su cuenta.
		// Antes, si la pantalla no permitía retroceso, ese intento abortaba y la
		// URL quedaba en el home mientras el store seguía creyendo que estabas en
		// la pantalla anterior: de ahí que el siguiente avance no funcionara.
		this.store
			.select(selectIsApplicantAMember)
			.pipe(take(1))
			.subscribe(isApplicantAMember => {
				this.store.dispatch(
					OnboardingProcessActions.syncProcessWithRoute({
						route: currentUrl,
						canSkipNextProcess: isApplicantAMember,
					})
				);
			});

		this.onboardingFlow.changingStepCompleted();
	}
}
